import React, { useEffect, useState } from 'react';
import { subscribeApiLoading } from '../api/client';

/**
 * Indeterminate top bar shown whenever there is at least one API request in-flight.
 * Helps users understand the app is working and prevents repeated “save” clicks.
 */
export function TopLoadingBar() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    return subscribeApiLoading((n) => setActive(n > 0));
  }, []);

  if (!active) return null;
  return <div className="topLoadingBar" aria-hidden="true" />;
}
